import * as Sentry from '@sentry/react';

import type { FeedEngineErrorPhase } from '../engine';

const MAX_REPORTS_PER_SESSION = 5;
const reportedSignatures = new Set<string>();

/**
 * Recovered-engine-error sink for the production feed: always logs, and forwards
 * each distinct failure to Sentry once per session (capped) so a client whose
 * measure/flush loop is degrading is visible without flooding.
 */
export function reportFeedEngineError(error: unknown, phase: FeedEngineErrorPhase): void {
  console.error(`[MessageFeed] engine ${phase} error:`, error);

  const signature = `${phase}:${error instanceof Error ? error.message : String(error)}`;
  if (reportedSignatures.has(signature) || reportedSignatures.size >= MAX_REPORTS_PER_SESSION) return;
  reportedSignatures.add(signature);

  Sentry.captureException(error, { tags: { feed_engine_phase: phase } });
}
